module.exports = __webpack_public_path__ + "img/classic_point.0ae2158b.png";